import React from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import axios from "axios";

//...................Employer Components...................................//
import Container from "./container/container";
import Candidate from "./component/extInterviewSchedule/selectCandidate";
import ScheduleExtInterview from "./component/extInterviewSchedule/extInterviewSchedule";
import InterviewTIming from "./component/extInterviewSchedule/interviewTiming";
import MyProfile from "./component/My-Profile/Myprofile";
import ScheduleInterview from "./component/scheduleInterviewer/scheduleInterviewer";
import Login from "./component/Login/Login";
import SignUp from "./component/SignUp/signUp";
import ResetPassword from "./component/ResetPassword/resetPassword";
import VerifiedEmailScreen from "./component/VerifiedEmailScreen/VerifiedEmailScreen";
import HelpAndFeedback from "./component/HelpAndFeedback/HelpAndFeedback";
// import OtpBox from './component/OTP/OtpBox'
// import NewInterview from './component/extInterviewSchedule/newInterview'
import LogedinReset from "./component/LogedinReset/LogedinReset";
import CreateInterview from "./component/CreateInterview/CreateNewInterview";
import PaymentReview from "./component/PaymentReview/PaymentReview";
import JobProfile from "./component/JobProfile/JobProfile";
import Success from "./component/CreateInterview/PaymentPreview/Success/success";
import CacheBuster from "./cacheBuster/cacheBuster";

axios.interceptors.request.use((req) => {
  console.log("Request...", req);
  return req;
});

axios.interceptors.response.use((res) => {
  console.log("response...", res);
  return res;
});

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      adminMode: true,
    };
  }

  closeModalVerify = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    let container = null;

    if (
      localStorage.getItem("userToken") != null &&
      localStorage.getItem("userToken") != "" &&
      localStorage.getItem("userToken") != undefined
    ) {
      container = (
        <Container props={this.props}>
          <Switch>
            <Route
              path="/interview"
              exact
              strict
              component={ScheduleInterview}
            />
            <Route path="/profile" exact strict component={JobProfile}></Route>
            <Route
              path="/interview/createNew"
              exact
              strict
              component={CreateInterview}
            />
            {/* <Route path="/interview/jobs" exact strict component={NewInterview}/> */}
            <Route
              path="/interview/candidate"
              exact
              strict
              component={Candidate}
            />
            <Route
              path="/interview/external"
              exact
              strict
              component={ScheduleExtInterview}
            />
            <Route
              path="/interview/timing"
              exact
              strict
              component={InterviewTIming}
            />
            <Route path="/feedback" exact strict component={HelpAndFeedback} />
            <Route path="/logedinreset" exact strict component={LogedinReset} />
            <Route path="/myProfile" exact strict component={MyProfile} />
            <Route path="/status" exact strict component={Success} />
            <Redirect to="/interview" />
          </Switch>
        </Container>
      );
    } else {
      container = (
        <>
          <Switch>
            <Route
              path="/login"
              exact
              strict
              render={(props) => <Login {...props} />}
            />
            <Route path="/signup" exact strict component={SignUp} />
            <Route
              path="/reset"
              exact
              strict
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              path="/verifiedEmail"
              exact
              strict
              component={VerifiedEmailScreen}
            />
            <Redirect to="/login" />
          </Switch>
        </>
      );
    }
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

          return <div className="App">{container}</div>;
        }}
      </CacheBuster>
    );
  }
}

export default withRouter(App);
